"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFunnelChartUiConfig = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var cloneDeep_1 = tslib_1.__importDefault(require("lodash/cloneDeep"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var assign_1 = tslib_1.__importDefault(require("lodash/assign"));
var sdk_ui_1 = require("@gooddata/sdk-ui");
var uiConfig_1 = require("../../constants/uiConfig");
var bucket_1 = require("../../constants/bucket");
var bucket_title_measures_svg_1 = tslib_1.__importDefault(require("../../assets/funnel/bucket-title-measures.svg"));
var bucket_title_view_svg_1 = tslib_1.__importDefault(require("../../assets/funnel/bucket-title-view.svg"));
function setFunnelChartUiConfig(referencePoint) {
    var referencePointConfigured = cloneDeep_1.default(referencePoint);
    assign_1.default(referencePointConfigured[uiConfig_1.UICONFIG], uiConfig_1.disabledOpenAsReportConfig);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.MEASURES, "icon"], bucket_title_measures_svg_1.default);
    set_1.default(referencePointConfigured, [uiConfig_1.UICONFIG, bucket_1.BUCKETS, sdk_ui_1.BucketNames.VIEW, "icon"], bucket_title_view_svg_1.default);
    return referencePointConfigured;
}
exports.setFunnelChartUiConfig = setFunnelChartUiConfig;
//# sourceMappingURL=funnelChartUiConfigHelper.js.map